import React, { useState, useEffect, useMemo } from "react";
import { useHistory } from "react-router-dom";
import ReactTableComponent from "../../components/Table/ReactTableComponent";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
  Table,
} from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { callAPI } from "../../_helper/index";
import { toast } from "react-toastify";
import ReactTooltip from "react-tooltip";
import { Spinner } from 'reactstrap';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
function Driver() {
  const COLUMNS = [
    {
      Header: "Action",
      Footer: "Action",
      accessor: (originalRow, rowIndex) => {
        return (
          <>

            <UncontrolledDropdown className="menu-dropdown">
              <DropdownToggle>
                <div className="dots"></div>
                <div className="dots"> </div>
                <div className="dots"></div>
              </DropdownToggle>
              <DropdownMenu>

                <Row>
                  <Col>
                    {originalRow.StatusId == 2 ? (
                      <>
                        <button
                          data-tip
                          data-for="ApproveDriver"
                          onClick={(e) => {
                            approveDriver(originalRow.Id);
                          }}
                          className="btn-edit"
                        >
                          <i className="now-ui-icons design-2_ruler-pencil" />
                          Approve
                        </button>
                        <ReactTooltip id="ApproveDriver" place="top" effect="solid">
                          Approve Driver
                        </ReactTooltip>
                      </>
                    ) : (
                      ""
                    )}
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <button
                      data-tip
                      data-for="EditDriver"
                      onClick={(e) => {
                        history.push(`/admin/manage-driver/${originalRow.Id}`);
                      }}
                      className="btn-edit"
                    >
                      <i className="now-ui-icons design-2_ruler-pencil" />
                      Edit
                    </button>
                    <ReactTooltip id="EditDriver" place="top" effect="solid">
                      Edit Driver
                    </ReactTooltip>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <button
                      data-tip
                      data-for="DeleteDriver"
                      onClick={(e) => deleteDriver(originalRow.Id)}
                      className="btn-edit"
                    >
                      <i className="now-ui-icons ui-1_simple-remove" />
                      Delete
                    </button>
                    <ReactTooltip id="DeleteDriver" place="top" effect="solid">
                      Delete Driver
                    </ReactTooltip>
                  </Col>
                </Row>

              </DropdownMenu>
            </UncontrolledDropdown>

          </>
        );
      },
      Cell: ({ value }) => {

        return value;
      },
    },
    {
      Header: "First Name",
      Footer: "First Name",
      accessor: "FirstName",
    },
    {
      Header: "Last Name",
      Footer: "Last Name",
      accessor: "LastName",
    },
    {
      Header: "Email Address",
      Footer: "Email Address",
      accessor: "EmailAddress",
    },
    {
      Header: "Status",
      Footer: "Status",
      accessor: "DriverStatus",
    },
    {
      Header: "Device ID",
      Footer: "Device ID",
      accessor: "DeviceID",
    },
    {
      Header: "Authorization",
      Footer: "Authorization",
      accessor: "AuthKey",
    },
  ];

  const [users, setUsers] = useState([]);
  const history = useHistory();
  const columns = useMemo(() => COLUMNS, []);
  const data = useMemo(() => users, []);
  const [IsLoading, setIsLoading] = useState(true)
  const [driverStatus, setdriverStatus] = useState([])
  useEffect(() => {
    loadDrivers();
    driverStatusHandler();
  }, []);

  const loadDrivers = (id = 0) => {
    var response = callAPI(`/api/drivers/all/${id}`, "GET", null);
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        setUsers(res.data);
      } else {
        toast.error(res.message);
      }
    });
  };

  const deleteDriver = (id) => {
    if (confirm("Are you sure you want to delete this driver?")) {
      setIsLoading(true)
      var response = callAPI(`/api/drivers/${id}`, "DELETE", null);
      response.then((res) => {
        setIsLoading(false)
        if (res.success) {
          toast.success("Driver Deleted Successfully!!!");
          loadDrivers(0);
        } else {
          toast.error(res.message);
        }
      });
    }
  };

  const approveDriver = (id) => {
    setIsLoading(true)
    var response = callAPI(`/api/driver-status/${id}`, "GET", null);
    response.then((res) => {
      setIsLoading(false)
      if (res.success) {
        toast.success("Driver Status Updated!!!");
        loadDrivers(0);
      } else {
        toast.error(res.message);
      }
    });
  };

  let renderRow = users.map((user) => {
    return (
      <tr key={user.Id}>
        <td className="td-actions text-left">
          {user.StatusId == 2 ? (
            <>
              <button
                data-tip
                data-for="ApproveDriver"
                onClick={(e) => {
                  approveDriver(user.Id);
                }}
                className="btn btn-warning"
              >
                <i className="now-ui-icons design-2_ruler-pencil" />
              </button>
              <ReactTooltip id="ApproveDriver" place="top" effect="solid">
                Approve Driver
              </ReactTooltip>
            </>
          ) : (
            ""
          )}
          &nbsp;
          <button
            data-tip
            data-for="EditDriver"
            onClick={(e) => {
              history.push(`/admin/manage-driver/${user.Id}`);
            }}
            className="btn btn-info"
          >
            <i className="now-ui-icons design-2_ruler-pencil" />
          </button>
          <ReactTooltip id="EditDriver" place="top" effect="solid">
            Edit Driver
          </ReactTooltip>
          &nbsp;
          <button
            data-tip
            data-for="DeleteDriver"
            onClick={(e) => deleteDriver(user.Id)}
            className="btn btn-danger"
          >
            <i className="now-ui-icons ui-1_simple-remove" />
          </button>
          <ReactTooltip id="DeleteDriver" place="top" effect="solid">
            Delete Driver
          </ReactTooltip>
        </td>
        <td className="text-left">{user.FirstName}</td>
        <td className="text-left">{user.LastName}</td>
        <td className="text-left">{user.EmailAddress}</td>
        <td className="text-left">{user.DriverStatus}</td>
        <td className="text-left">{user.DeviceID}</td>
        <td className="text-left">{user.AuthKey}</td>
      </tr>
    );
  });


  const driverStatusHandler = () => {
    var response = callAPI(`/api/driver-status`, "GET", null);
    response.then((res) => {
      console.log(res);
      if (res.success) {
        setdriverStatus(res.data);
      } else {
        toast.error(res.message);
      }
    });
  }

  let renderStatusOptions =
    driverStatus.length > 0 || driverStatus.roles != undefined
      ? driverStatus.map((st) => {
        return (
          <option key={st.Id} value={st.Id}>
            {st.Status}
          </option>
        );
      })
      : "";


  const onInputChange = (e) => {
    setIsLoading(true)

    loadDrivers(e.target.value)
  }

  return (
    <>
      <PanelHeader size="lg" />
      {
        IsLoading &&
        <div className="loader">
          <Spinner color="white" />
        </div>

      }
      <div className="content">
        <Row>
          <Col xs={12} md={12}>
            <Card className="card-chart">
              <CardHeader>
                <Row>
                  <Col md={4}>
                    <CardTitle tag="h4">
                      Driver Management
                    </CardTitle>
                  </Col>
                  <Col md={3}>
                    <select
                      name="Status"
                      id="ddlOrderStatus"
                      className="form-control h38"
                      onChange={(e) => onInputChange(e)}
                    >
                      <option value="0">All</option>
                      { }
                      {renderStatusOptions}
                    </select>
                  </Col>
                  <Col className="text-right">
                    <button
                      className="btn btn-info"
                      onClick={(e) => {
                        history.push("/admin/manage-driver");
                      }}
                    >
                      Add Driver
                    </button>
                  </Col>
                </Row>


              </CardHeader>
              <CardBody>
                {users.length ? (
              
                
                  <ReactTableComponent data={users} columns={columns} />
             
             
                ) : null}
                {/* <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      <th>Action</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th>Email Address</th>
                      <th>Status</th>
                      <th>Device ID</th>
                      <th>Authorization</th>
                    </tr>
                  </thead>
                  <tbody>{renderRow}</tbody>
                </Table> */}
              </CardBody>
              <CardFooter>
                <div className="stats"></div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Driver;
